import { requestFromServer } from './api-client';

const BranchClient = {
  getAllByIdRole: async () => {
    return requestFromServer('v1/Branches_Origin/getAllByIdRole');
  },
  getAllByTransporters: async (transportersIds) => {
    return requestFromServer(`/v1/Branches_Origin/getAllByTransporters/${transportersIds}`);
  },
  getBranchRegions: async () => {
    return requestFromServer('v1/Branches_Origin/getBranchRegions');
  },
};

export default BranchClient;
